import React from 'react';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';

import MbButton from 'components/atoms/MbButton';
import MbTooltip from 'components/atoms/MbTooltip';

const useStyles = makeStyles((theme) => ({
  tableCellAlign: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > div': { marginRight: 5 },
    '& > div:last-child': { marginLeft: 10, marginRight: 0 },
    '& > p': {
      whiteSpace: 'noWrap',
      textAlign: 'center',
      '&.blue': { color: theme.palette.common.blue },
      '&.red': { color: theme.palette.common.red },
    },
    '&:list-child': { marginRight: 0 },
  },
  icoBox: {
    display: 'flex',
    fontSize: 15,
    color: '#4d5059',
    cursor: 'pointer',
    '& > div': { marginRight: 5 },
    '&:last-child > div': { marginRight: 0 },
  },
  lineBreakStyle: { whiteSpace: 'normal !important' },
}));

const IconAreaWrap = (props) => {
  const classes = useStyles();
  const {
    children,
    text,
    icon,
    onClick,
    toolTipTitle,
    textColor,
    lineBreak = false,
    className,
  } = props;
  return (
    <>
      <div className={classes.tableCellAlign}>
        {typeof text !== 'undefined' && text !== '' && (
          <p
            className={clsx(
              'blue' === textColor && 'blue',
              'red' === textColor && 'red',
              !!lineBreak && classes.lineBreakStyle,
              className
            )}
          >
            {text}
          </p>
        )}
        {typeof icon !== 'undefined' && icon !== false ? (
          <div className={classes.icoBox}>
            <MbTooltip title={toolTipTitle}>
              <MbButton iconBtn icon={icon} onClick={onClick} />
            </MbTooltip>
          </div>
        ) : (
          children
        )}
      </div>
    </>
  );
};

export default IconAreaWrap;
